export default {
    contactPageTitle: "Get in touch",
    contactPageDescription: "Have a question or feedback? Send us a message and we&apos;ll get back to you as soon as we can.",
    contactInfoLabel: "Contact Info",
    contactInfoEmailLabel: "Email",
    contactInfoResponseTimeLabel: "Response Time",
    contactInfoResponseTimeValue: "Within 24-48 hours",
    contactFormTitle: "Send a message",
    contactFormNameLabel: "Name",
    contactFormNamePlaceholder: "Your name",
    contactFormEmailLabel: "Email",
    contactFormEmailPlaceholder: "your@email.com",
    contactFormSubjectLabel: "Submit",
    contactFormSubjectPlaceholder: "What is this about ?",
    contactFormMessageLabel: "Message",
    contactFormMessagePlaceholder: "Your message...",
    contactFormSubmitActionLabel: "Send message",
}